import { ProjectPageHeader, type ProjectPageHeaderProps } from './ProjectPageHeader';
import { useActiveChatContext } from '../context/ActiveChatContext';

type ProjectPageHeaderContainerProps = Omit<
  ProjectPageHeaderProps,
  'isResearchAssistantWorking'
> & {
  projectId: string;
};

/**
 * Supplies {@link ProjectPageHeader} with the one piece of state it can't own:
 * whether the Research Assistant is mid-turn.
 *
 * A run is in flight while the agent is streaming or waiting on an answer it
 * has asked for — in both cases it is holding the project's dataset for work it
 * hasn't finished, which is what the switch control has to wait out. With no
 * chat open the context is ``null`` and nothing is running.
 */
export const ProjectPageHeaderContainer = (props: ProjectPageHeaderContainerProps) => {
  const activeChat = useActiveChatContext();
  const runState = activeChat?.page.runState;
  const isResearchAssistantWorking = runState === 'streaming' || runState === 'awaiting_input';

  return <ProjectPageHeader {...props} isResearchAssistantWorking={isResearchAssistantWorking} />;
};

export default ProjectPageHeaderContainer;
